import { PersonBlock, ResponsiveTableRow } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { DmcResponsiveCheckboxTable } from '../../../common/DmcResponsiveTable'
import { getLastPathElement, getPidFromIdentifier } from '../../../../util/StringUtil'

export default function CreateTreePersonTable({ potentialTreeEntities, onPersonSelectionChange }) {
  const { t } = useTranslation()

  return (
    <DmcResponsiveCheckboxTable
      atSizeColumns={{
        default: {
          labels: [t('role.label', 'Role'), t('person.label', 'Person')],
        },
      }}
      totalColumnCount={2}
      onSelectionChange={onPersonSelectionChange}
    >
      {potentialTreeEntities.map((potentialTreeEntity) => {
        return (
          <ResponsiveTableRow
            key={potentialTreeEntity.role}
            name={potentialTreeEntity.role}
            column1={potentialTreeEntity.role}
            column2={
              <PersonBlock
                size="md"
                avatarProps={{
                  sex: getLastPathElement(potentialTreeEntity.person.gender.type).toLowerCase(),
                }}
                name={
                  potentialTreeEntity.person?.names?.[0]?.nameForms?.[0]?.fullText
                    ? potentialTreeEntity.person.names[0].nameForms[0].fullText
                    : '?'
                }
                details={getPidFromIdentifier(potentialTreeEntity.person.identifiers)}
              />
            }
          />
        )
      })}
    </DmcResponsiveCheckboxTable>
  )
}
